import { render } from "./expertDetail.vue?vue&type=template&id=2f7c375c&scoped=true"
import script from "./expertDetail.vue?vue&type=script&lang=js"
export * from "./expertDetail.vue?vue&type=script&lang=js"

import "./expertDetail.vue?vue&type=style&index=0&id=2f7c375c&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7c375c"]])

export default __exports__